import { evaluationCourseList } from "./Service";
import { atomWithDefault } from "jotai/utils";

export const RateOtherAtom = atomWithDefault(async () => {
    return await evaluationCourseList();
});
